// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"T3-z","displaySixCardTiles":"U3-z"};